if (!customElements.get('porchet-product-qr')) {
  customElements.define('porchet-product-qr', class extends HTMLElement {
    connectedCallback() {
      this.querySelector('details').addEventListener('toggle', () => {
        const image = this.querySelector('[data-qr-image]');
        if (!this.querySelector('details').open || image.childElementCount || typeof QRCode === 'undefined') return;
        new QRCode(image, {text:this.dataset.url, width:160, height:160, colorDark:'#111111', colorLight:'#ffffff', correctLevel:QRCode.CorrectLevel.M});
        image.setAttribute('role', 'img');
        image.setAttribute('aria-label', this.dataset.alt);
        image.querySelectorAll('img').forEach(img => img.alt = this.dataset.alt);
        image.querySelectorAll('canvas').forEach(canvas => canvas.setAttribute('aria-hidden', 'true'));
      });
    }
  });
}
